export class MailController {

    constructor($scope, XrayMailDao, JFrogEventBus, $timeout, XRayUIModelSaver, TOOLTIPS, $state, XRayUIState) {
        this.XrayMailDao = XrayMailDao;
        this.JFrogEventBus = JFrogEventBus;
        this.getMailData();
        this.XRayUIState = XRayUIState
        this.$state = $state;
        this.mailSettingsForm = null;
        this.testReceiptForm = null;
        this.modelSaver = XRayUIModelSaver.createInstance(this, ['mail']);
        this.$timeout = $timeout;
        this.EVENTS = JFrogEventBus.getEventsDefinition();

        this.TOOLTIP = TOOLTIPS.admin.mail;

        $scope.$parent.Settings.showButtons = true;
        $scope.$parent.Settings.currentSubController = this;
        if (this.XRayUIState.getState('isSaas')) {
            //console.log('Saas');
            this.$state.go('home');
        }
        this.$timeout(() => {
            if (this.XRayUIState.getState('isSaas')) {
                //console.log('Saas');
                this.$state.go('home');
            }
        }, 500)


    }

    getMailData() {
        this.XrayMailDao.get().$promise.then((mail) => {
            this.mail = mail;
            this.modelSaver.save();
//            this.JFrogEventBus.dispatch(this.EVENTS.FORM_CLEAR_FIELD_VALIDATION, true);
        });
    }

    save(form) {
//        this.JFrogEventBus.dispatch(this.EVENTS.FORM_SUBMITTED, form.$name);
        if (this.mailSettingsForm.$valid) {
            let payload = _.cloneDeep(this.mail);
            this.XrayMailDao.update({}, payload).$promise.then(() => {
                this.modelSaver.save();
            });
        }
    }


    cancel() {
        this.$state.go('home');
    }

    testReceipt(form) {
//        this.JFrogEventBus.dispatch(this.EVENTS.FORM_SUBMITTED, form.$name);
        if (this.testReceiptForm.$valid) {
            this.XrayMailDao.test(this.mail);
        }
    }

    canSave() {
        return this.mailSettingsForm.$valid;
    }

	checkLocalHost(retypeVal) {

		if (typeof retypeVal !== 'undefined') {

			if (retypeVal.toLowerCase().indexOf('localhost') > -1 || retypeVal.toLowerCase().indexOf(
					'127.0.0.1') > -1) {

				return false;
			} else {

				return true;
			}
		}
		//return !retypeVal || (retypeVal && this.input.password === retypeVal);
	}
}



// WEBPACK FOOTER //
// ./modules/xray/states/settings/tabs/mail/mail.controller.js